// extracted by mini-css-extract-plugin
export default {"container":"sJ-z","disabled":"tJ-z","bgBlack":"uJ-z","content":"vJ-z","countdown":"wJ-z","topCaption":"xJ-z","topHeading":"yJ-z","heading":"zJ-z","copy":"AJ-z"};